import React from 'react';
import { HashRouter, Link } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import PropTypes from 'prop-types';
import Header from './Components/Header';
import Overview from './Routes/Regional/Overview';
import { Base, Clearfix, Left, Right } from './Symbols/layout';
import ScrollToTop from './Components/ScrollToTop';
import E404 from './Routes/Regional/E404';
import Region from './Routes/Regional/Region'
import { AreaListOrdered } from './Components/AreaList';
import Map from './Components/Map/Regional'
import TitleSymbol from './Symbols/Title'
import { linkHeader } from './Components/Header/styles';
import Title from './Symbols/Title';
import { css } from 'emotion';
import { getIsElectionInProgress } from './Utils/Getters';
import withDataLoader from './Utils/withDataLoader';

const mb2 = css`
	margin-bottom: 2rem;
`

class App extends React.PureComponent {

	ref = React.createRef();
	state = {
		meta: {
			turnout: 0,
			count: 0
		},
		regions: [],
		parties: [],
		hasData: false,
		err: false
	}

	componentDidMount() {
		this.load();
	}

	load = () => {
		this.props.loadDataAsync(['vysledky_full.json']).then(([data]) => {
			this.setState(Object.assign(data.body, {
				hasData: true,
				err: false
			}));
		})
			.catch((err) => {
				this.setState({ err });
			});

	}

	render() {
		// Prevent rendering of refresh button and info panel when either elections are over or data is not ready yet
		const canUpdate = this.state.hasData && getIsElectionInProgress(this.state.meta);
		const regions = this.state.regions;

		return <HashRouter>
			<ScrollToTop scrollContainer={this.ref}>
				<Base innerRef={this.ref}>
					<Header load={this.load} canUpdate={canUpdate}>
						<Route
							path="/kraj/"
							render={() => (
								<Link className={linkHeader} to="/">Zpět na celkový přehled</Link>
							)}
						/>
					</Header>
					<Left>
						<Switch>
							<Route
								exact
								path="/"
								render={() => (
									<Overview
										year={this.props.year}
										rootUrl={this.props.rootUrl}
										parties={this.state.parties}
										meta={this.state.meta}
										hasData={this.state.hasData}
									/>
								)}
							/>
							<Route
								exact
								path="/kraj/:id"
								render={({ match }) => {
									const region = this.state.regions.find(region => region.id.toString() === match.params.id);

									return (
										<Region
											id={match.params.id}
											year={this.props.year}
											rootUrl={this.props.rootUrl}
											meta={this.state.meta}
											err={this.state.err}
											hasData={this.state.hasData}
											region={region}
										/>
									)
								}}
							/>
							<Route
								render={() => <>
									<Header canUpdate={false} />
									<Left>
										<E404 year={this.props.year} />
									</Left>
								</>}
							/>
						</Switch>
					</Left>
					<Route
						path={['/kraj/:id', '/']}
						render={({ match }) => {
							const regionId = match.params && match.params.id

							return (
								<Right>
									<TitleSymbol className={mb2}>Jak si stojí strany v jednotlivých krajích</TitleSymbol>
									<Title>
										Vybrat kraj
										<Route
											path="/kraj/"
											render={() => (
												<Link to="/" style={{ 'float': 'right', marginBottom: '10px' }}>Zpět na celkový přehled</Link>
											)}
										/>
									</Title>
									<Map regions={regions} meta={this.state.meta} selectedRegionId={regionId} />
									<AreaListOrdered type="kraj" list={regions} />
								</Right>
							)
						}}
					/>
					<Clearfix />
				</Base>
			</ScrollToTop>
		</HashRouter>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	links: PropTypes.arrayOf(PropTypes.shape({
		url: PropTypes.string,
		text: PropTypes.string
	}))
};

App.defaultProps = {
	links: []
};

export default withDataLoader(App)
